import { useState } from 'react';
import { Button } from '../../components/common/button';
import Loading from '../../components/common/loading';
import AuthForm from '../../components/forms/auth-form';
import { Container } from '../../components/layout/container';
import Layout from '../../components/layout/layout';
import { useTranslation } from '../../lib/i18n';
import { useUser } from '../user-context';

export const Confirm = ({
  action,
  heading,
  loginDescription,
  buttonLabel = undefined,
  children = null,
}) => {
  const { user, userInitialized } = useUser();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  if (!buttonLabel) {
    buttonLabel = t('confirm');
  }

  const confirm = () => {
    setLoading(true);
    action();
  };

  return (
    <Layout canonicalUrl='/profile' robots='noindex'>
      <Container>
        {userInitialized ? (
          <>
            {user ? (
              <>
                <h1 className='mb-10'>{heading}</h1>
                <Button
                  loading={loading}
                  onClick={confirm}
                  className='my-4 block'
                  filled={true}
                >
                  {buttonLabel}
                </Button>
              </>
            ) : (
              <AuthForm
                loginHeading={heading}
                loginDescription={loginDescription}
              />
            )}
          </>
        ) : (
          <>
            <h1 className='mb-10'>{heading}</h1>
            <Loading></Loading>
          </>
        )}
        {children && <>{children}</>}
      </Container>
    </Layout>
  );
};
